import { t } from '@lingui/core/macro'
import { isGrpcConnectNotFoundError } from '@jotta/grpc-connect-client/error'
import { useGetFlow } from '@jotta/grpc-connect-client/vipps'
import { ErrorPage } from '@jotta/ui/ErrorPage'
import { autoLogin } from '@jotta/utils/auth'
import { type ReactNode, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'
import Spinner from '@jotta/ui/Spinner'
import { PublicLayout } from '../../components/Layout/PublicLayout'

export function PaymentStatusRoute() {
  const { flowId = '' } = useParams()
  const { data, error } = useGetFlow({
    variables: {
      flowId,
    },
    throwOnError: false,
  })
  useEffect(() => {
    if (data) {
      switch (data.state) {
        case 'success':
          {
            if (data.username && data.token) {
              autoLogin({
                redirectTo: data.redirectUrl,
                token: data.token,
                username: data.username,
                replace: true,
              })
            } else {
              window.location.replace(data.redirectUrl)
            }
          }
          break

        case 'failed':
          window.location.replace(data.redirectUrl)
          break
        default:
          exhaustiveGuard(data)
      }
    }
  }, [data])

  return (
    <PublicLayout
      section="paymentstatus"
      className="flex flex-col items-center p-16"
    >
      <PaymentStatus error={error} />
    </PublicLayout>
  )
}

export function PaymentStatus({ error }: { error: Error | null }) {
  if (error) {
    if (isGrpcConnectNotFoundError(error)) {
      return (
        <Content title="">
          <ErrorPage hideFooter notFound />
        </Content>
      )
    }
    return (
      <Content title={t`An error occured!`}>
        <ErrorPage hideFooter error={error} />
      </Content>
    )
  }
  return (
    <Content title={t`Waiting for payment confirmation`}>
      <Spinner />
    </Content>
  )
}

function Content({
  title,
  children,
}: {
  title: ReactNode
  children?: ReactNode
}) {
  return (
    <>
      <h1 className="title-lg">{title}</h1>
      <div className="mx-auto p-8">{children}</div>
    </>
  )
}
